export default __webpack_public_path__ + "static/media/krandom.199a41cd.png";